import { Icon } from "semantic-ui-react";

import { Checkbox } from "@/components/ui/checkbox";
import { SELECT_COLUMN_ID } from "constants/Constants";
import { TableLink } from "components/BaseTableV3/TableLink";
import { formatDate } from "components/helpers";
import { EmailAttachmentsTableActions } from "./EmailAttachmentsTableActions";
export const parseEmailAttachments = (emailAttachments = []) => {
  //This may need to be changed. Kind of a placeholder for now.
  return emailAttachments.map(emailAttachment => ({
    id: emailAttachment.id,
    name: emailAttachment.name,
    file_name: emailAttachment.file_name,
    description: emailAttachment.description,
    is_graphical: emailAttachment.is_graphical,
    created_at: emailAttachment.created_at,
    created_by_user_id: emailAttachment.created_by_user_id,
  }));
};

export const getEmailAttachmentsTableColumns = () => {
  return [
    {
      id: SELECT_COLUMN_ID,
      size: 60,
      enableSorting: false,
      meta: {
        isDisplay: true,
      },
      header: ({ table }) => (
        <Checkbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onCheckedChange: checked => table.toggleAllRowsSelected(!!checked),
            "aria-label": "Select all rows",
          }}
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected() && !row.getIsSelected(),
            onCheckedChange: checked => row.toggleSelected(!!checked),
            "aria-label": "Select row",
          }}
        />
      ),
    },
    {
      header: "ID",
      id: "id",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <TableLink href={`/settings/email_attachments/${row.getValue("id")}`}>
          {row.getValue("id")}
        </TableLink>
      ),
    },
    {
      header: "Email Attachment Name",
      id: "name",
      accessorKey: "name",
      size: 100,
      cell: ({ row }) => (
        <span title={row.getValue("name")}>{row.getValue("name")}</span>
      ),
    },
    {
      header: "File Name",
      id: "file_name",
      accessorKey: "file_name",
      size: 100,
      cell: ({ row }) => (
        <span title={row.getValue("file_name")}>
          {row.getValue("file_name")}
        </span>
      ),
    },
    {
      header: "Type",
      id: "is_graphical",
      accessorKey: "is_graphical",
      size: 80,
      enableSorting: false,
      cell: ({ row }) => (
        <span>
          <Icon name={row.original.is_graphical ? "paint brush" : "file"} />
          {row.original.is_graphical ? "Graphical" : "File"}
        </span>
      ),
    },
    {
      header: "Created At",
      id: "created_at",
      accessorKey: "created_at",
      size: 100,
      cell: ({ row }) => formatDate(row.original.created_at),
    },
    {
      header: "Updated At",
      id: "updated_at",
      accessorKey: "updated_at",
      size: 100,
      cell: ({ row }) => formatDate(row.original.updated_at),
    },
    {
      header: "Description",
      id: "description",
      accessorKey: "description",
      size: 100,
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      size: 60,
      enableSorting: false,
      enableResizing: false,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <EmailAttachmentsTableActions original={row.original} />
      ),
    },
  ];
};

export const getEmailAttachmentsTableFilters = () => {
  return [
    {
      key: "name",
      title: "Attachment Name",
      type: "input",
      placeholder: "Search by attachment name...",
    },
    {
      key: "file_name",
      title: "File Name",
      type: "input",
      placeholder: "Search by file name...",
    },
    {
      key: "created_at",
      title: "Created At",
      type: "dateRange",
    },
    {
      key: "updated_at",
      title: "Updated At",
      type: "dateRange",
    },
    {
      key: "description",
      title: "Description",
      type: "input",
      placeholder: "Search by description...",
    },
  ];
};
